import { LoginPattern } from 'app/assets/images/icons';
import TextInput from 'app/components/Form/Inputs/TextInput';
import { useCustomForm } from 'app/hooks/useCustomForm';
import { _t } from 'app/utils/i18n';
import {
  constants,
  getFromLocalStorage,
  setInLocalStorage,
} from 'app/utils/localStorage';
import { resetPassword, verifyResetPasswordToken } from 'auth/Requests';
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import CriteriaValidation from 'users/components/CriteriaValidation';
import { passwordsValidationSchema } from '../validationSchema';
import ReCAPTCHA from 'react-google-recaptcha';
import styles from './ResetNewPassword.module.scss';
import { useMutation } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';
import Loader from 'app/components/Loader';
import { path } from 'app/utils/path';
import { toast } from 'react-toastify';
import { checkIsMockGoogleRecaptcha } from 'app/utils/check-mock-google-recaptcha';

const currentLanguage = getFromLocalStorage(constants.language);

const ResetNewPassword: FunctionComponent = () => {
  const reRef = useRef<ReCAPTCHA>();
  const [isLoading, setIsLoading] = useState(true);
  const [isValidToken, setIsValidToken] = useState(true);
  const [userData, setUserData] = useState<any>({});
  const location = useLocation();
  const history = useHistory();
  const token = location?.search.split('?token=')[1];
  const checkResetAccessToken = useMutation(verifyResetPasswordToken);
  const sendUserNewData = useMutation(resetPassword);
  const {
    handleSubmit,
    changeHandler,
    getValues,
    formState: { errors },
  } = useCustomForm(passwordsValidationSchema, {});
  const values = getValues();

  const setLang = (lng: string) => {
    setInLocalStorage(constants.language, lng);
    window.location.reload();
  };
  const checkToken = async () => {
    try {
      let reToken = '';
      if (checkIsMockGoogleRecaptcha()) {
        reToken = await reRef.current.executeAsync();
        reRef.current.reset();
      }
      await checkResetAccessToken
        .mutateAsync({ token, reToken })
        .then((res) => {
          setUserData(res?.payload?.records);
        });
      setIsLoading(false);
    } catch (err) {
      console.log('err', err);
      setIsLoading(false);
      setIsValidToken(false);
    }
  };

  const onSubmit = async () => {
    try {
      let reToken = '';
      if (checkIsMockGoogleRecaptcha()) {
        reToken = await reRef.current.executeAsync();
        reRef.current.reset();
      }
      await sendUserNewData
        .mutateAsync({
          userData: {
            user_id: userData?.user_id,
            password: values.password,
            token,
          },
          reToken,
        })
        .then((res) => {
          if (res.code === 200) {
            toast.success(res.message);
            history.replace(path.auth.SIGN_IN);
            const languageLocale = localStorage.getItem(constants.language);
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem(constants.language, languageLocale as any);
          }
        });
    } catch (err) {
      console.log('error', err);
    }
  };

  useEffect(() => {
    (async () => {
      await checkToken();
    })();
  }, []);

  return (
    <div className={styles.ResetNewPassword}>
      {checkIsMockGoogleRecaptcha() && (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as any}
          size="invisible"
          ref={reRef as any}
        />
      )}
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {isValidToken ? (
            <>
              <LoginPattern />
              <div className={styles.loginBox}>
                <form className={styles.Form} onSubmit={handleSubmit(onSubmit)}>
                  <h4>{_t('users:rest_password')}</h4>
                  <div className="mb-20">
                    <TextInput
                      type="password"
                      label={_t('basic:password')}
                      error={errors?.password?.message}
                      name="password"
                      onChange={(e) => changeHandler('password', e)}
                    />
                  </div>
                  <div className="mb-20">
                    <TextInput
                      type="password"
                      label={_t('basic:confirm_password')}
                      error={errors?.confirm_password?.message}
                      name="confirm_password"
                      onChange={(e) => changeHandler('confirm_password', e)}
                    />
                  </div>
                  <div className="mt-30">
                    <CriteriaValidation value={values?.password} />
                  </div>
                  <div className={styles.button_Box}>
                    <button> {_t('login:Send')}</button>
                    {currentLanguage == 'en' ? (
                      <a
                        onClick={() => setLang('ar')}
                        style={{ cursor: 'pointer' }}
                      >
                        {_t('basic:ar')}
                      </a>
                    ) : (
                      <a
                        onClick={() => setLang('en')}
                        style={{ cursor: 'pointer' }}
                      >
                        {_t('basic:en')}
                      </a>
                    )}
                  </div>
                </form>
              </div>
            </>
          ) : (
            <h1>Something went wrong</h1>
          )}
        </>
      )}
    </div>
  );
};

export default ResetNewPassword;
